import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  question: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    marginTop: theme.spacing(1),
  },
  contentWraper: {
    display: 'flex',
    gap: theme.spacing(1.5),
  },
  qAndAContainer: {
    width: 'fit-content',
    display: 'flex',
    gap: theme.spacing(1),
    flexDirection: 'column',
  },
  qAndAWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  horizontalDivider: {
    borderTop: `1px solid ${theme.palette.dividerV2.main}`,
    marginBottom: theme.spacing(1),
  },
  answerText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.description,
    whiteSpace: 'pre-line',
  },
  questionText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.5px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.primary,
  },
  externalLinkText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.select.light,
  },
  externalLinkContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  indexIcon: {
    width: theme.spacing(3),
    height: theme.spacing(2.5),
    fontSize: '20px',
  },
}))
